import { lazy } from 'react';

// ----------------------------------------------------------------------

const CustomerPage = lazy(() => import('../pages/Customer.page'));

// ----------------------------------------------------------------------

const CustomerRoutes = [
    {
        path: '/customer',
        element: <CustomerPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { CustomerRoutes };
